/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd..
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { clearButton } from './clear-button-styles.js';
import { fieldShared } from './field-shared-styles.js';
import { inputFieldContainer } from './input-field-container-styles.js';

export const inputFieldShared = [fieldShared, inputFieldContainer, clearButton];
